module.exports = __webpack_public_path__ + "media/images/dashboards/stock-f92ec5c447c0e833a2dc88007958208a.png";